import apiClient from '@/utils/apiClient'

export const getBillingInfo = async (merchantId: string, storeId: string) => {
    const response = await apiClient.post('/billing/mantle/plans', {
        merchantId,
        storeId,
    })
    return response.data.data
}
export const createSubscription = async ({
    merchantId,
    storeId,
    planId,
    interval,
    returnUrl,
}: {
    merchantId: string
    storeId: string
    planId: string
    interval: string
    returnUrl: string
}) => {
    const response = await apiClient.post(
        '/billing/mantle/create-subscription',
        {
            merchantId,
            storeId,
            planId,
            interval,
            returnUrl,
        }
    )
    return response.data.data
}
export interface SyncQuotaPayload {
    mantleCustomerId: string
    mantleSubscriptionId: string
    planId: string
    planName: string
    planAmount: number
    planInterval: string
    monthlyResponseLimit: number
    billingCycleStart: string | null
    billingCycleEnd: string | null
    billingCycleAnchor: string | null
    subscriptionActive: boolean
}

export const syncQuota = async (payload: SyncQuotaPayload) => {
    const response = await apiClient.post('/billing/mantle/sync-quota', payload)
    return response.data.data
}

export const updateSubscription = async ({
    merchantId,
    storeId,
    planId,
    interval,
    subscriptionId,
    returnUrl,
}: {
    merchantId: string
    storeId: string
    planId: string
    interval: string
    subscriptionId: string
    returnUrl: string
}) => {
    const response = await apiClient.patch(
        '/billing/mantle/update-subscription',
        {
            merchantId,
            storeId,
            planId,
            interval,
            subscriptionId,
            returnUrl,
        }
    )
    return response.data.data
}
